import { KYMW0600Model } from '../kymw0600.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW0300OutputModel } from 'src/app/commons/kymw03/kymw0300/vo/kymw0300-output.model';

/**
 * Pコードを指定し、商品情報を取得するクラス
 *
 * @export GetCandidateListInfoService
 * @class GetCandidateListInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCandidateListInfoService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW0600Model;
  outputModel: KYMW0300OutputModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCandidateListInfoService
   */
  private getBody(): PlessRequest {
    let conditionList = [];
    let searchObj = {};
    
    if (this.outputModel.pcodeList.length > 0) {
      // Pコードリスト検索
      this.outputModel.pcodeList.map((item) => {
        const addItem = {
          parameter: {
            GuideGoodsName: "",
            GuideStandardName: "",
            TagId: "",
            GoodsMark: "",
            CoopCode: "",
            Duties: "",
            PCode: item,
            ItemCode: "",
          }
        }
        conditionList.push(addItem);
      })
    } 
    else if (this.outputModel.itemcodeList.length > 0) {
      // アイテムコードリスト検索
      this.outputModel.itemcodeList.map((item) => {
        const addItem = {
          parameter: {
            GuideGoodsName: "",
            GuideStandardName: "",
            TagId: "",
            GoodsMark: "",
            CoopCode: "",
            Duties: "",
            PCode: "",
            ItemCode: item,
          }
        }
        conditionList.push(addItem);
      })
    } 
    else {
      const guideGoodsName = this.outputModel.guideGoodsNameList;
      const guideStandardName = this.outputModel.guideStandardNameList;
      const tagId = this.outputModel.tagId;
      const goodsMark = this.outputModel.goodsMark;
      const coopCodeList = this.outputModel.coopCodeList;
      const duties = this.outputModel.duties;

      const maxLength = Math.max(guideGoodsName.length, guideStandardName.length, tagId.length, goodsMark.length, coopCodeList.length, duties.length);

      conditionList = Array.from({ length: maxLength }, (_, index) => ({
        parameter: {
          GuideGoodsName: guideGoodsName[index] !== undefined ? guideGoodsName[index] : "",
          GuideStandardName: guideStandardName[index] !== undefined ? guideStandardName[index] : "",
          TagId: tagId[index] !== undefined ? tagId[index] : "",
          GoodsMark: goodsMark[index] !== undefined ? goodsMark[index] : "",
          CoopCode: coopCodeList[index] !== undefined ? coopCodeList[index] : "",
          Duties: duties[index] !== undefined ? duties[index] : "",
          PCode: "",
          ItemCode: "",
        }
      }))
    }

    searchObj = {
      Rec: {
        parameter: {
          PCode: this.outputModel.pcode,
          ItemCode: this.outputModel.itemCode,
          JanCode: this.outputModel.janCode,
          MakerName: this.outputModel.makerName,
          TagSearchType: this.outputModel.tagSearchType,
          GoodsMarkSearchType: this.outputModel.goodsMarkSearchType,
          DataKbnFlg: this.outputModel.dataKbnFlg,
          GoodsDiv: this.outputModel.goodsDiv,
          BuyerCode: this.outputModel.buyerCode,
          AdmitStatus: this.outputModel.admitStatus,
          RegistDateFrom: this.outputModel.registDateFrom,
          RegistDateTo: this.outputModel.registDateTo,
          UpdateDateFrom: this.outputModel.updateDateFrom,
          UpdateDateTo: this.outputModel.updateDateTo,
          ClassCode: this.outputModel.classCode,
          MiddleClassCode: this.outputModel.middleClassCode,
          SmallClassCode: this.outputModel.smallClassCode,
          OrdrClientCode: this.outputModel.ordrClientCode,
          OrdrClientKanji: this.outputModel.ordrClientKanji,
          PayeeClientCode: this.outputModel.payeeClientCode,
          PayeeClientKanji: this.outputModel.payeeClientKanji,
        },
        combination: conditionList
      }
    }
    return new PlessRequest({ search: searchObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetCandidateListInfoService
   */
  execute(model: KYMW0600Model, outputVO: KYMW0300OutputModel, successFunc: Function = null): void {
    this.model = model;
    this.outputModel = outputVO;
    this.send('KYMW0600getCandidateListInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCandidateListInfoService
   */
  success(data: any): void {
    if (data.length > 100) {
      this.dialogService.openAlertGetMessage('I0102', ['100','100'],)
    }
    // サーバからの結果を元に、候補一覧データを更新する
    this.model.updateTargetGoodsInfo(data);
  }
}
